import { render, staticRenderFns } from "./ActivityConfig.vue?vue&type=template&id=ae23d8f0&scoped=true"
import script from "./ActivityConfig.vue?vue&type=script&lang=js"
export * from "./ActivityConfig.vue?vue&type=script&lang=js"
import style0 from "./ActivityConfig.vue?vue&type=style&index=0&id=ae23d8f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae23d8f0",
  null
  
)

export default component.exports